import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import OtpInput from "react-otp-input";
import WestSharpIcon from "@mui/icons-material/WestSharp";
import routes from "../../api/routes";
import useApiRequest from "../../api/api";
import { useSnackbar } from "../utils/SnackbarProvider";
import LoadingBackdrop from "../utils/loader";
import { darkColors } from "../../theme/colors";
import { fontSizes } from "../../theme/font-sizes";
import useWindowWidth from "../../hooks/window-size/use-window-width";
import GradientButton from "../utils/gradient-button";
import CloseIcon from "@mui/icons-material/Close";
const Otp = ({
  handleBack,
  handleContinue,
  isFromRegister,
  email,
  fromForgotPW,
}) => {
  const [otp, setOtp] = useState("");
  const { makeApiCall } = useApiRequest();
  const showSnackbar = useSnackbar(); // Use the global Snackbar
  const [seconds, setSeconds] = useState(59);
  const [isLoading, setIsLoading] = useState(false);

  const [resendText, setResendText] = useState(
    `Resend in 0:${seconds < 10 ? `0${seconds}` : seconds}`
  );

  const handleChange = (value) => {
    setOtp(value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      email: email, // email coming from props
      otp: otp, // otp entered by the user
    };
    setIsLoading(true);

    const response = await makeApiCall(
      routes.auth.verify,
      "POST",
      payload // Send the OTP as part of the request body
    );

    setIsLoading(false);

    if (response.success) {
      handleContinue(response.data); // Pass the token to the parent component
    } else {
      // Handle the case where OTP verification fails
      showSnackbar("OTP verification failed", "error");
      console.error("OTP verification failed:", response.message);
    }
  };

  const handleResend = async (e) => {
    const payload = {
      email: email, // email coming from props
    };

    const response = await makeApiCall(
      routes.auth.resend,
      "POST",
      payload // Send the OTP as part of the request body
    );

    if (response.success) {
      // You can add logic here to handle successful verification
      showSnackbar(response.message, "success");
      setSeconds(59);
    } else {
      // Handle the case where OTP verification fails
      showSnackbar(response.message, "error");
      console.error("OTP verification failed:", response.message);
    }
  };
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 768;

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timer); // Clear interval on component unmount
    } else {
      setResendText("Resend Code");
    }
  }, [seconds]);

  useEffect(() => {
    if (seconds > 0) {
      setResendText(`Resend in 0:${seconds < 10 ? `0${seconds}` : seconds}`);
    }
  }, [seconds]);
  return (
    <Box
      sx={{
        width: isMobile ? "100%" : "100%",
        background: "transparent",
        color: "white",
      }}
    >
      <LoadingBackdrop isLoading={isLoading} />

      <Typography
        sx={{
          color: darkColors.gray600,
          display: "flex",
          justifyContent: "right",
          textAlign: "right",
          mr: -2,
          mt: -1,

          cursor: "pointer",
        }}
        // variant={windowWidth <= 768 ? "h5" : "h4"}
        fontSize={fontSizes.body}
        gutterBottom
        onClick={handleBack}
      >
        <CloseIcon />
        {/* <Typography sx={{ marginLeft: 1 }}>Back</Typography>{" "} */}
      </Typography>
      <Typography
        sx={{
          color: darkColors.gray900,
          display: "flex",
          justifyContent: isMobile ? "center" : "left",
          textAlign: "left",
          mt: 5,
        }}
        // variant={windowWidth <= 768 ? "h5" : "h4"}
        fontWeight="bold"
        fontSize={fontSizes.superHeading5}
        fontFamily={"MontserratBold"}
        gutterBottom
      >
        Verify Your Email
      </Typography>
      <Typography
        sx={{
          ml: isMobile ? 1 : 0,
          display: "flex",
          justifyContent: "left",
          textAlign: "left",
          //   width: "280px",
          fontSize: fontSizes.body,
          fontWeight: 600,
          color: darkColors.gray900,
          mt: 2,
        }}
        // variant={isMobile ? "body2" : fonts.body}

        gutterBottom
      >
        Please check your email, a one time code has been sent to your email at{" "}
        {email}. If you can't find the email please check your spam folder as
        well.
      </Typography>

      <Box marginLeft={"-2%"} marginTop={2}>
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={4}
          renderInput={(props) => <input {...props} />}
          inputStyle={{
            width: "17%",
            height: "3.5rem",
            margin: "0.9rem",
            border: `1px solid white`, // Border color
            borderRadius: "4px",
            fontSize: "1.5rem",
            textAlign: "center",
            background: "transparent",
            color: "white",
          }}
          containerStyle={{
            justifyContent: "left",
          }}
        />
      </Box>
      <Box display={"flex"} justifyContent={"right"}>
        <Typography
          component="span"
          display={"flex"}
          justifyContent={"left"}
          sx={{
            fontSize: isMobile ? "11px" : fontSizes.info,
            ml: isMobile ? 2 : 0,
            color: darkColors.buttonTop,
            textAlign: "left",
            mr: 1.5,
            cursor: seconds > 0 ? "default" : "pointer", // Change cursor based on seconds
            "&:hover": {
              textDecoration: seconds > 0 ? "none" : "underline", // Underline when clickable
            },
          }}
          onClick={seconds === 0 ? handleResend : undefined} // Call handleResend if seconds is 0
        >
          {resendText}
        </Typography>
      </Box>

      {/* <Button
        fullWidth
        variant="contained"
        onClick={handleSubmit}
        sx={{
          mt: 9,
          py: 1,
          background: darkColors.but,
          height: isMobile ? "45px" : "60px",
          borderRadius: "4px",
          textTransform: "none",
          fontSize: isMobile ? 12 : fontSizes.heading4,
          letterSpacing: 1,
          fontWeight: 400,
          transition: "box-shadow 0.3s ease",
          "&:hover": {
            boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.4)", // Drop shadow effect
          },
        }}
      >
        Continue
      </Button> */}
      <Box mt={5}>
        <GradientButton
          width={"100%"}
          text={"Continue"}
          onClick={handleSubmit}
        />
      </Box>
    </Box>
  );
};

export default Otp;
